import {
  Route,
  Routes,
  useHistoryCustomBack,
  usePanelHistoryTop,
} from 'weblite-router'
import { goBackInRoomProfilePanel } from '$logic/router'
import { AddAdmin } from '$comp/_app/components/leftPanel/components/add-admin/add-admin'
import { AddMembers } from '$comp/_app/components/leftPanel/components/add-members'
import { CreateHall } from '$comp/_app/components/leftPanel/components/create-hall'
import {
  EditInviteLink,
  CreateInviteLink,
  InviteLinks,
} from '$comp/_app/components/leftPanel/components/invite-links-manage'
import { ChannelAdminRights } from '$comp/_app/components/leftPanel/components/channel-admin-rights'
import { GroupAdminRights } from '$comp/_app/components/leftPanel/components/group-admin-rights'
import { GroupMemberPermissionOverride } from '$comp/_app/components/leftPanel/components/group-member-permissions-override'
import {
  DefineHallAccessibility,
  EditHallAccessibility,
} from '$comp/_app/components/leftPanel/components/hall-accessibility'
import { GroupExceptionUsers } from '$comp/_app/components/leftPanel/components/group-exception-users'
import { GroupMemberPermissions } from '$comp/_app/components/leftPanel/components/group-member-permissions'
import { Admins } from '$comp/_app/components/leftPanel/components/admins'
import { HallProfile } from '$comp/_app/components/leftPanel/components/hall-profile'
import { RemovedUsers } from '$comp/_app/components/leftPanel/components/removed-users'
import { RemoveMembers } from '$comp/_app/components/leftPanel/components/remove-members'
import { HallSettings } from '$comp/_app/components/leftPanel/components/hall-settings'
import { JoinedViaInviteLink } from '$comp/_app/components/leftPanel/components/joined-via-invite-link'
import { UserProfile } from '$comp/_app/components/leftPanel/components/user-profile/user-profile'
import { WappProfile } from '$comp/_app/components/leftPanel/components/wapp-profile'
import { AddGroupExceptionUser } from '$comp/_app/components/leftPanel/components/add-group-exception-user'
import { ForwardList } from '$comp/_app/components/leftPanel/components/forward-list'
import { MemberList } from '$comp/_app/components/leftPanel/components/member-list/member-list'
import { ChatListSearch } from '$comp/_app/components/leftPanel/components/chat-list-search/chat-list-search'
import { SharedMedia } from '$comp/_app/components/leftPanel/components/shared-media'
import { ShareContactList } from '$comp/_app/components/leftPanel/components/share-contact-list'
import { VisibilityHandler } from './components/visibility-handler'

// TODO type-safety
type Pages = Record<string, any>

// NOTE: Do NOT change order!
export const ROOM_PROFILE_PAGES: Pages = {
  WAPP_PROFILE: WappProfile,
  HALL_PROFILE: HallProfile,
  USER_PROFILE: UserProfile,
  SHARED_MEDIA: SharedMedia,

  HALL_SETTINGS: HallSettings,
  DEFINE_HALL_ACCESSIBILITY: DefineHallAccessibility,
  EDIT_HALL_ACCESSIBILITY: EditHallAccessibility,

  CREATE_HALL: CreateHall,

  ADD_HALL_MEMBERS: AddMembers,

  HALL_SUBSCRIBERS: MemberList,
  GROUP_MEMBER_PERMISSIONS: GroupMemberPermissions,
  GROUP_EXCEPTIONS: GroupExceptionUsers,
  ADD_GROUP_EXCEPTION_MEMBER: AddGroupExceptionUser,
  GROUP_MEMBER_PERMISSIONS_OVERRIDE: GroupMemberPermissionOverride,

  HALL_ADMINS: Admins,
  ADD_HALL_ADMIN: AddAdmin,
  CHANNEL_ADMIN_PERMISSIONS: ChannelAdminRights,
  GROUP_ADMIN_PERMISSIONS: GroupAdminRights,

  HALL_REMOVED_USERS: RemovedUsers,
  HALL_REMOVE_MEMBER: RemoveMembers,

  HALL_INVITE_LINKS: InviteLinks,
  CREATE_INVITE_LINK: CreateInviteLink,
  EDIT_INVITE_LINK: EditInviteLink,
  JOINED_VIA_INVITE_LINK: JoinedViaInviteLink,

  FORWARD_LIST: ForwardList,
  SHARE_CONTACT_LIST: ShareContactList,
}

export function RoomProfile({ zIndex = 2 }: { zIndex?: number }) {
  const panelTop = usePanelHistoryTop('roomProfile')

  useHistoryCustomBack(() => {
    goBackInRoomProfilePanel()
  }, [])

  if (!panelTop?.location) return null

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { state } = panelTop

  return (
    <VisibilityHandler zIndex={zIndex}>
      <Routes>
        <Route
          name="roomProfile"
          routeTransitions={{
            name: 'zoomFade',
            slideStyles: { backgroundColor: '#F6F6F6' },
          }}
        >
          {Object.keys(ROOM_PROFILE_PAGES).map(
            (page: keyof typeof ROOM_PROFILE_PAGES) => {
              const Component = ROOM_PROFILE_PAGES[page]
              // @ts-ignore
              return (
                <Route
                  key={page}
                  name={page}
                  element={<Component {...state} />}
                />
              )
            },
          )}
        </Route>
      </Routes>
    </VisibilityHandler>
  )
}
